import { DEFAULT_PAGE_TITLE } from '../context/constants';
import { Helmet } from 'react-helmet';
const PageMetaData = ({
  title
}) => {
  const defaultTitle = DEFAULT_PAGE_TITLE;
  return <Helmet>
      <title>{defaultTitle}</title>
    </Helmet>;
};
export default PageMetaData;
